import {
  createContext,
  createRef,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import AuthService from "../service/auth";

const AuthContext = createContext({} as AuthContextProps);
const contextRef = createRef();

export function AuthProvider({
  authService,
  children,
}: {
  authService: AuthService;
  children: React.ReactNode;
}) {
  const [user, setUser] = useState({});

  const logIn = useCallback(
    async (email: string, password: string) => {
      return await authService.login(email, password);
    },
    [authService]
  );

  const logout = useCallback(async () => {}, []);

  const context = useMemo(() => ({ logIn }), [logIn]);
  return (
    <AuthContext.Provider value={context}>{children}</AuthContext.Provider>
  );
}

export default AuthContext;
export const fetchToken = () => contextRef.current;
export const useAuth = () => useContext(AuthContext);
